import { render, staticRenderFns } from "./AppointmentOtherInfos.vue?vue&type=template&id=6c44bf1f&scoped=true&"
import script from "./AppointmentOtherInfos.vue?vue&type=script&lang=js&"
export * from "./AppointmentOtherInfos.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentOtherInfos.vue?vue&type=style&index=0&id=6c44bf1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44bf1f",
  null
  
)

export default component.exports